// extracted by mini-css-extract-plugin
export var par = "SubTitle-module--par--3nn-w";
export var small = "SubTitle-module--small--1U5hQ";